const c = {
  name: "Hands00001",
  dimensions: { width: 26, height: 34 },
  content: `
<svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
	 viewBox="0 0 26 34" style="enable-background:new 0 0 26 34;" xml:space="preserve">
<style type="text/css">
	.st0{fill: currentColor;}
</style>
<g>
	<g>
		<path class="st0" d="M18,4.4v2.1C17.4,6.2,16.7,6,16,6c-0.8,0-1.6,0.2-2.2,0.7C13.2,5.1,11.8,4,10,4C8.3,4,6.8,5.1,6.2,6.7
			C5.6,6.2,4.8,6,4,6c-2.2,0-4,1.8-4,4v11c0,7.2,5.8,13,13,13c7.2,0,13-5.8,13-13V4.4C26,2.1,24.3,0,22,0S18,2.1,18,4.4z M24,4.4V21
			c0,6.1-4.9,11-11,11C6.9,32,2,27.1,2,21v-4c0-1.1,0.9-2,2-2h6c1.1,0,2,0.9,2,2s-0.9,2-2,2H6v2h4c1.2,0,2.3-0.5,3-1.4
			c0.7,0.8,1.8,1.4,3,1.4c2.2,0,4-1.8,4-4h2.1v-2H20V4.4C20,3,21,2,22,2C23,2,24,3,24,4.4z M16,8c1.1,0,2,0.9,2,2v7c0,1.1-0.9,2-2,2
			c-1.1,0-2-0.9-2-2v-7C14,8.9,14.9,8,16,8z M8,8c0-1.1,0.9-2,2-2c1.1,0,2,0.9,2,2v5.5c-0.6-0.3-1.3-0.5-2-0.5H8V8z M6,10v3H4
			c-0.7,0-1.4,0.2-2,0.5V10c0-1.1,0.9-2,2-2C5.1,8,6,8.9,6,10z"/>
	</g>
</g>
</svg>
  `
};
export {
  c as Hands00001
};
